export default class {
  constructor() {
    this.e_hover = '';
    this.e_mask = '';
    this.hideTimeout = null;
    this.showTimeout = null;
    this.ifMouseOn = false;
  }
  init(hover, mask) {
    this.e_hover = document.getElementById(hover);
    this.e_mask = document.getElementById(mask);
    this.hoverEvent();
    this.maskEvent();
  }
  hoverEvent() {
    var self = this;
    this.e_hover.addEventListener('mouseenter', function() {
      self.showFunc();
    });
    this.e_hover.addEventListener('mouseleave', function() {
      self.hidefunc();
    });
  }
  maskEvent() {
    var self = this;
    this.e_mask.addEventListener('mouseenter', function() {
      self.ifMouseOn = true;
    });
    this.e_mask.addEventListener('mouseleave', function() {
      self.ifMouseOn = false;
      self.hidefunc();
    });
  }
  showFunc() {
    var self = this;
    clearTimeout(self.hideTimeout);
    self.hideTimeout = null;
    clearTimeout(self.showTimeout);
    self.showTimeout = null;
    self.showTimeout = setTimeout(function() {
      self.e_mask.style.display = 'block';
    }, 300);
  }
  hidefunc() {
    var self = this;
    clearTimeout(self.showTimeout);
    self.showTimeout = null;
    clearTimeout(self.hideTimeout);
    self.hideTimeout = null;
    self.hideTimeout = setTimeout(function() {
      if (!self.ifMouseOn) {
        self.e_mask.style.display = 'none';
      }
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/components/header/hoverEvent.js